import { defineStore } from "pinia";
import { useContentsStore } from "./ContentsStore";
import { DocumentInfo } from "~/entities/DocumentInfo";
import { ContentList } from "~/entities/ContentList";

export const useDocumentStore = defineStore("DocumentStore", () => {
  const contentStore = useContentsStore();

  const documents = ref<ContentList<DocumentInfo>>();
  const document = ref<DocumentInfo>();
  const loading = ref(false);

  const fetchOne = async (contentsId: string) => {
    loading.value = true;
    document.value = undefined;
    try {
      document.value = await contentStore.getDetail<DocumentInfo>(contentsId);
    } finally {
      loading.value = false;
    }
  };

  // optionsにis_free, search_wordが入ります。
  const fetch = async (page: number, pageSize: number, planId: string | undefined, options?: Record<string, any>) => {
    loading.value = true;
    documents.value = undefined;
    try {
      documents.value = await contentStore.getList<ContentList<DocumentInfo>>(page, pageSize, {
        contents_types: ["document"],
        plan_id: planId,
        ...options,
      });
    } finally {
      loading.value = false;
    }
  };

  // コンテンツ閲覧画面下部に表示するデータを取得する
  const fetchPlanDocuments = async (
    page: number,
    pageSize: number,
    planId: string | undefined,
    exclusionContentsId: string | undefined,
  ) => {
    loading.value = true;
    try {
      const res = await contentStore.getList<ContentList<DocumentInfo>>(page, pageSize, {
        contents_types: ["document"],
        plan_id: planId,
        exclusion_contents_id: exclusionContentsId,
        is_ignore_featured: true,
      });
      return res.contents;
    } finally {
      loading.value = false;
    }
  };

  return {
    document,
    documents,
    loading,
    fetchOne,
    fetch,
    fetchPlanDocuments,
  };
});
